// src/utils/requisites.js
//
// РЕКВИЗИТЫ ПРОДАВЦА — В ОДНОМ МЕСТЕ.
//
// 🔑 ЗАЧЕМ ОТДЕЛЬНЫЙ ФАЙЛ, А НЕ СТРОКИ ПО МЕСТАМ.
//    Реквизиты нужны минимум в четырёх местах: подвал сайта, страница
//    контактов, политика конфиденциальности и пользовательское соглашение.
//    Пока они были вписаны строками, документы РАСХОДИЛИСЬ: в текстах
//    оставались заглушки `[ИНН]`, `[ОГРНИП]`, `[полное наименование]`,
//    хотя в подвале данные уже были. Это класс «источник, отставший от
//    реальности» — главный источник вранья в проекте.
//
// ⚠️ ДАННЫЕ ВЗЯТЫ ИЗ ЕГРИП, А НЕ ВЫДУМАНЫ (проверено 2026-10-07 через
//    открытые источники; актуально на 07.10.2026).
//
// 🔴 ЧЕГО ЗДЕСЬ СОЗНАТЕЛЬНО НЕТ: УЛИЦЫ И ДОМА.
//    В ЕГРИП адрес ИП указан как «Белгородская область, город Старый Оскол»
//    — БЕЗ улицы, дома и офиса (регистр этих деталей не публикует).
//    Выдумывать их НЕЛЬЗЯ: неверный адрес в реквизитах хуже отсутствующего,
//    потому что по нему предъявляют претензии. Уточнит владелец — допишем.
//
// ⚠️ ПРО НАЛОГОВЫЙ РЕЖИМ. По данным ЕГРИП применяется НПД (налог на
//    профессиональный доход), категория — микропредприятие. Указывать ли
//    при НПД «ОГРНИП» вместо статуса плательщика НПД — вопрос к юристу,
//    он ОТКРЫТ (см. SHOP_ROADMAP.txt §7). Пока показываем ОГРНИП: он
//    настоящий и проверяемый, а его отсутствие — точно нарушение.

export const REQUISITES = {
  legalName: 'Индивидуальный предприниматель Цар Владимир Олегович',
  shortName: 'ИП Цар Владимир Олегович',
  // Полное имя без статуса — для подстановки в юридические тексты.
  fullName: 'Цар Владимир Олегович',
  inn: '312822609298',
  ogrnip: '315312800004651',
  // Дата регистрации в качестве ИП — из ЕГРИП.
  registeredAt: '14.05.2015',
  region: 'Белгородская область',
  city: 'г. Старый Оскол',
  // ⚠️ Улица/дом — только от владельца. Сейчас пусто ОСОЗНАННО.
  streetAddress: '',
  phone: '8 904 095 01 10',
  phoneHref: 'tel:89040950110',
  email: 'info@reklama-oskol.ru',
  site: 'reklama-oskol.ru',
  siteUrl: 'https://reklama-oskol.ru',
};

/**
 * Однострочная строка реквизитов для подвала и документов.
 * Пример: «ИП Цар Владимир Олегович · ИНН 312822609298 · ОГРНИП 315312800004651»
 */
export const REQUISITES_LINE =
  `${REQUISITES.shortName} · ИНН ${REQUISITES.inn} · ОГРНИП ${REQUISITES.ogrnip}`;

/** Адрес для документов. Без улицы, если владелец её ещё не дал. */
export const REQUISITES_ADDRESS = [
  REQUISITES.region,
  REQUISITES.city,
  REQUISITES.streetAddress,
].filter(Boolean).join(', ');

export default REQUISITES;
